import { render } from "./CustomDeleteResourceModal.vue?vue&type=template&id=613fb2a4"
import script from "./CustomDeleteResourceModal.vue?vue&type=script&lang=js"
export * from "./CustomDeleteResourceModal.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CustomDeleteResourceModal.vue"]])

export default __exports__